export enum Permission {
  ENTER_COURSE = "ENTER_COURSE",
  ASSIGN_COURSE = "ASSIGN_COURSE",
  STUDENT_MANAGE = "STUDENT_MANAGE",
}
